export const CHANGE_IS_LOGIN_PAGE = 'CHANGE_IS_LOGIN_PAGE'